<template>
  <div class="wlx-coperation-enter-wrapper">
    <PartnerManager></PartnerManager>
  </div>
</template>

<script>
import PartnerManager from "page/xSchool/manager/PartnerManager.vue";
export default {
  data() {
    return {};
  },
  components: {
    PartnerManager
  }
};
</script>

<style>
</style>
